import React from 'react'
import { Link } from 'react-router-dom';
function ServiceOne() {
    return (
        <div>
            <>
                {/* rts service post area  Start*/}
                <div className="rts-service-area rts-section-gapBottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="rts-title-area service text-center">
                                    <p className="pre-title">Nos Services</p>
                                    <h2 className="title">Prestations de services On/Off Shore</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid service-main plr--120-service mt--50 plr_md--0 pl_sm--0 pr_sm--0">
                        <div className="background-service row">
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner one">
                                    <div className="service-details">
                                        <Link to={'/service/transit'}>
                                            <h5 className="title">Transit</h5>
                                        </Link>
                                        <p className="disc">
                                            Services de transit professionnels pour vos marchandises avec
                                            suivi complet et gestion optimisée des flux logistiques
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/transit'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner two">
                                    <div className="service-details">
                                        <Link to={'/service/fourniture-materiaux-construction'}>
                                            <h5 className="title">Fourniture de matériaux de construction</h5>
                                        </Link>
                                        <p className="disc">
                                            Approvisionnement en matériaux de construction de qualité pour
                                            tous vos projets avec livraison rapide et prix compétitifs
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/fourniture-materiaux-construction'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner three">
                                    <div className="service-details">
                                        <Link to={'/service/construction-btp-genie-civil'}>
                                            <h5 className="title">Construction BTP &amp; Génie civil</h5>
                                        </Link>
                                        <p className="disc">
                                            Réalisation de projets de construction et génie civil avec
                                            expertise technique et respect des normes en vigueur
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/construction-btp-genie-civil'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner four">
                                    <div className="service-details">
                                        <Link to={'/service/fourniture-equipements-industriels'}>
                                            <h5 className="title">Fourniture d'équipements et matériels industriels</h5>
                                        </Link>
                                        <p className="disc">
                                            Solutions complètes en équipements industriels adaptés à vos
                                            besoins avec installation et maintenance professionnelles
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/fourniture-equipements-industriels'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner five">
                                    <div className="service-details">
                                        <Link to={'/service/nettoyage-industriel-assainissement'}>
                                            <h5 className="title">Nettoyage industriel &amp; assainissement</h5>
                                        </Link>
                                        <p className="disc">
                                            Services de nettoyage industriel et assainissement pour
                                            maintenir vos espaces de travail propres et sécurisés
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/nettoyage-industriel-assainissement'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner six">
                                    <div className="service-details">
                                        <Link to={'/service/fourniture-equipement-general'}>
                                            <h5 className="title">Fourniture d'équipement général de l'entreprise</h5>
                                        </Link>
                                        <p className="disc">
                                            Équipement complet pour votre entreprise avec sélection de
                                            matériels adaptés et solutions sur mesure pour votre activité
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/fourniture-equipement-general'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner seven">
                                    <div className="service-details">
                                        <Link to={'/service/mise-disposition-personnel'}>
                                            <h5 className="title">Mise à disposition de personnel</h5>
                                        </Link>
                                        <p className="disc">
                                            Mise à disposition de personnel qualifié et expérimenté pour
                                            répondre à vos besoins temporaires ou permanents en ressources
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/mise-disposition-personnel'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                            {/* start single Service */}
                            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
                                <div className="service-one-inner eight">
                                    <div className="service-details">
                                        <Link to={'/service/transport-logistique'}>
                                            <h5 className="title">Transport &amp; logistique</h5>
                                        </Link>
                                        <p className="disc">
                                            Solutions complètes de transport et logistique pour optimiser
                                            vos chaînes d'approvisionnement avec suivi en temps réel
                                        </p>
                                        <Link
                                            className="rts-read-more btn-primary"
                                            to={'/service/transport-logistique'}
                                        >
                                            <i className="far fa-arrow-right" />
                                            En savoir plus
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* end single Services */}
                        </div>
                    </div>
                </div>
                {/* rts service post area ENd */}
            </>

        </div>
    )
}

export default ServiceOne